import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navigation from "./Navigation";
import Hamburger from "../reusable/Hamburger/Hamburger";
import { useTranslation } from "react-i18next";
import { useAuth } from "../pages/authPage/utils/AuthProvider";

export default function Footer() {
  const [infoBoxOpen, setInfoBoxOpen] = useState(false);
  const infoBoxRef = useRef(null);
  const toggleRef = useRef(null);
  const hamburgerRef = useRef(null);
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language.slice(0, 2);
  const otherLang = currentLang === "en" ? "ka" : "en"; // flip
  const otherLabel = otherLang === "en" ? "EN" : "GE"; // what to show

  const { token } = useAuth();
  /**
   * Changes the language of the application.
   * @param {string} lang - language code, e.g. 'en' or 'ka'
   */
  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  function handleInfoToggle() {
    setInfoBoxOpen(!infoBoxOpen);
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        infoBoxRef.current &&
        !infoBoxRef.current.contains(event.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setInfoBoxOpen(false);
      }
    };
    const handleScroll = () => {
      setInfoBoxOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className="header-box">
        {/* Regular Navigation */}
        <Link className="side-nav-bar" to="/">
          <img
            src="/logo.png"
            alt="Makerspace logo"
            className="nav-image"
          />
          <Navigation device="desktop" />
        </Link>

        {/* Footer Section */}
        <section className="bar-info">
          <section className="footer-menu">
            <h2>{t("company")}</h2>
            <Link className="footer-links" to="/About">
              <h3>{t("about_us")}</h3>
            </Link>
            <a
              className="footer-links"
              target="_blank"
              rel="noopener noreferrer"
              area-label="Makerspace location"
              alt="Makerspace location"
              href="https://www.google.com/maps/dir//Makerspace,+Lado+Gudiashvili+Square,+Tbilisi+0162,+Georgia/@41.6909958,44.8035254,17z/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x40440d9a3542444f:0xc579f4ed091da767!3e0?source=lnms"
            >
              <h3>{t("location")}</h3>
            </a>
          </section>

          <section className="socials-section">
            <h2>{t("socials")}</h2>
            <section className="socials">
              <a
                className="hover-effect"
                href="https://www.instagram.com/makerspace_club/"
                target="_blank"
                rel="noopener noreferrer"
                area-label="Makerspace Instagram"
                alt="Makerspace Instagram"
                name="instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="25"
                  fill="#FFFFFF"
                  stroke="currentColor"
                  height="25"
                  viewBox="0 0 50 50"
                >
                  <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                </svg>
              </a>
              <a
                className="hover-effect"
                href="https://www.facebook.com/Makerspacebar?mibextid=LQQJ4d"
                target="_blank"
                area-label="Makerspace Facebook"
                rel="noopener noreferrer"
                alt="Makerspace Facebook"
                name="facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="25"
                  height="25"
                  viewBox="0 0 30 30"
                  fill="currentColor"
                >
                  <path d="M15,3C8.373,3,3,8.373,3,15c0,6.016,4.432,10.984,10.206,11.852V18.18h-2.969v-3.154h2.969v-2.099c0-3.475,1.693-5,4.581-5 c1.383,0,2.115,0.103,2.461,0.149v2.753h-1.97c-1.226,0-1.654,1.163-1.654,2.473v1.724h3.593L19.73,18.18h-3.106v8.697 C22.481,26.083,27,21.075,27,15C27,8.373,21.627,3,15,3z"></path>
                </svg>
              </a>
              <a
                className="hover-effect"
                href="https://www.youtube.com/makerspacebar/"
                target="_blank"
                area-label="Makerspace Youtube"
                alt="Makerspace Youtube"
                rel="noopener noreferrer"
                name="youtube"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="25"
                  height="25"
                  viewBox="0 0 50 50"
                  fill="currentColor"
                >
                  <path d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z"></path>
                </svg>
              </a>
            </section>
          </section>
          <section className="footer-lang">
            <h2>{t('language')}</h2>

            <section className="translate-icon" ref={toggleRef}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="25"
                  height="25"
                  viewBox="0 0 50 50"
                  fill="currentColor"
                >
                  <path d="M 14 4 C 8.4886661 4 4 8.4886661 4 14 L 4 36 C 4 41.511334 8.4886661 46 14 46 L 36 46 C 41.511334 46 46 41.511334 46 36 L 46 14 C 46 8.4886661 41.511334 4 36 4 L 14 4 z M 25 9 C 33.82 9 41 16.18 41 25 C 41 25.47 40.979453 25.930625 40.939453 26.390625 C 40.339453 26.140625 39.69 26 39 26 L 26 26 L 26 38.830078 C 26.41 38.710078 26.809219 38.51 27.199219 38.25 C 28.039219 39.23 29.249141 39.880469 30.619141 39.980469 C 28.869141 40.640469 26.98 41 25 41 C 16.18 41 9 33.82 9 25 C 9 24.86 8.9997656 24.719844 9.0097656 24.589844 C 9.1297656 25.759844 10.010391 26.720937 11.150391 26.960938 C 11.530391 29.680937 12.700156 32.150625 14.410156 34.140625 C 15.240156 33.570625 16.120547 33.070391 17.060547 32.650391 C 16.470547 30.660391 16.109297 28.41 16.029297 26 L 13.830078 26 L 15.830078 24 L 24 24 L 24 11.169922 C 23.59 11.289922 23.190781 11.49 22.800781 11.75 C 21.960781 10.77 20.750859 10.119531 19.380859 10.019531 C 21.130859 9.3595312 23.02 9 25 9 z M 26 11.169922 L 26 16.960938 C 26.765 16.920938 27.518203 16.838437 28.251953 16.710938 C 28.985703 16.583438 29.700625 16.409453 30.390625 16.189453 C 30.118125 15.526953 29.815 14.915547 29.488281 14.361328 C 29.324922 14.084219 29.155684 13.821152 28.980469 13.574219 C 28.805254 13.327285 28.625391 13.095547 28.439453 12.880859 C 28.253516 12.666172 28.062715 12.469434 27.867188 12.289062 C 27.67166 12.108691 27.471563 11.944766 27.267578 11.800781 C 27.063594 11.656797 26.853887 11.531309 26.642578 11.425781 C 26.43127 11.320254 26.2175 11.234922 26 11.169922 z M 11 12 L 19 12 C 20.66 12 22 13.34 22 15 L 22 19 C 22 20.66 20.66 22 19 22 L 15 22 L 12.189453 24.810547 C 11.749453 25.250547 11 24.930547 11 24.310547 L 11 22 C 9.34 22 8 20.66 8 19 L 8 15 C 8 13.34 9.34 12 11 12 z M 30.339844 12.070312 C 30.524844 12.307813 30.704453 12.557578 30.876953 12.818359 C 31.049453 13.079141 31.215 13.349687 31.375 13.632812 C 31.535 13.915938 31.688437 14.211094 31.835938 14.515625 C 31.983438 14.820156 32.124766 15.135937 32.259766 15.460938 C 32.589766 15.310937 32.911563 15.149766 33.226562 14.978516 C 33.541562 14.807266 33.850391 14.624688 34.150391 14.429688 C 33.867891 14.184687 33.576172 13.950391 33.275391 13.728516 C 32.373047 13.062891 31.389844 12.505313 30.339844 12.070312 z M 35.580078 15.859375 C 35.170078 16.144375 34.744687 16.413359 34.304688 16.662109 C 33.864688 16.910859 33.409453 17.139609 32.939453 17.349609 C 33.234453 18.344609 33.472734 19.405078 33.646484 20.517578 C 33.733359 21.073828 33.803203 21.643672 33.857422 22.224609 C 33.911641 22.805547 33.950703 23.3975 33.970703 24 L 38.949219 24 C 38.921719 23.6125 38.87875 23.229688 38.820312 22.851562 C 38.761875 22.473437 38.689687 22.099922 38.601562 21.732422 C 38.513438 21.364922 38.409531 21.004062 38.292969 20.648438 C 38.176406 20.292813 38.046094 19.942109 37.902344 19.599609 C 37.758594 19.257109 37.601328 18.921875 37.431641 18.59375 C 37.261953 18.265625 37.079141 17.945312 36.884766 17.632812 C 36.690391 17.320312 36.485391 17.016328 36.267578 16.720703 C 36.049766 16.425078 35.820078 16.136875 35.580078 15.859375 z M 31.050781 18.080078 C 30.650781 18.207578 30.24375 18.321719 29.832031 18.421875 C 29.420313 18.522031 29.003906 18.608516 28.582031 18.681641 C 28.160156 18.754766 27.733203 18.814922 27.302734 18.861328 C 26.872266 18.907734 26.4375 18.940938 26 18.960938 L 26 24 L 31.970703 24 C 31.950703 23.4675 31.914609 22.941562 31.865234 22.425781 C 31.815859 21.91 31.753281 21.403828 31.675781 20.908203 C 31.598281 20.412578 31.506719 19.929063 31.402344 19.457031 C 31.297969 18.985 31.180781 18.525078 31.050781 18.080078 z M 18.029297 26 C 18.109297 28.13 18.429219 30.139922 18.949219 31.919922 C 19.349219 31.792422 19.75625 31.678281 20.167969 31.578125 C 20.579687 31.477969 20.996094 31.391484 21.417969 31.318359 C 22.261719 31.172109 23.125 31.079062 24 31.039062 L 24 26 L 18.029297 26 z M 31 28 L 39 28 C 40.66 28 42 29.34 42 31 L 42 35 C 42 36.66 40.66 38 39 38 L 39 40.310547 C 39 40.930547 38.250547 41.250781 37.810547 40.800781 L 35 38 L 31 38 C 29.34 38 28 36.66 28 35 L 28 31 C 28 29.34 29.34 28 31 28 z M 24 33.039062 C 23.6175 33.059062 23.23875 33.090469 22.863281 33.132812 C 22.487813 33.175156 22.114922 33.228594 21.748047 33.292969 C 21.381172 33.357344 21.018828 33.433438 20.662109 33.519531 C 20.305391 33.605625 19.954375 33.703047 19.609375 33.810547 C 19.881875 34.473047 20.185 35.084453 20.511719 35.638672 C 21.001797 36.47 21.54623 37.169824 22.132812 37.710938 C 22.523867 38.07168 22.934805 38.363164 23.357422 38.574219 C 23.56873 38.679746 23.7825 38.765078 24 38.830078 L 24 33.039062 z M 17.740234 34.539062 C 17.410234 34.689063 17.085781 34.850234 16.769531 35.021484 C 16.453281 35.192734 16.144609 35.375312 15.849609 35.570312 C 16.697109 36.305312 17.629219 36.939453 18.632812 37.455078 C 18.967344 37.626953 19.310156 37.784688 19.660156 37.929688 C 19.475156 37.692188 19.295547 37.442422 19.123047 37.181641 C 18.950547 36.920859 18.785 36.650312 18.625 36.367188 C 18.465 36.084063 18.311563 35.788906 18.164062 35.484375 C 18.016562 35.179844 17.875234 34.864063 17.740234 34.539062 z"></path>
                </svg>
                <button
                  onClick={() => switchLanguage(otherLang)}
                  className="lang-text"
                >
                  {otherLabel}
                </button>{" "}
              </div>
            </section>
          </section>

          {/* Hamburger / Info Box Toggle */}
          <Hamburger
            onClick={handleInfoToggle}
            open={infoBoxOpen}
            buttonRef={hamburgerRef}
          />
          {infoBoxOpen && (
            <section className="info-box" ref={infoBoxRef}>
              <pre>
                <>
                  <section className="mobile-menu">
                    <Link className="hover-effect" to="/Djs">
                      <h1>{t("dj_booking")}</h1>
                    </Link>
                    <Link className="hover-effect" to="/Gallery">
                      <h1>{t("gallery")}</h1>
                    </Link>
                    
                    <section className="mobile-menu-login">
                      
                      <Link className="hover-effect" to="/Rentals">
          <h1>{t("rentals")}</h1>
        </Link>

                    </section>
                  </section>
                  <section className="footer-menu-mobile">
                    <h2>{t("company")}</h2>
                    <Link className="footer-links" to="/About">
                      <h3>{t("about_us")}</h3>
                    </Link>
                    <a
                      className="footer-links"
                      target="_blank"
                      rel="noopener noreferrer"
                      alt="Makerspace location"
                      area-label="Makerspace location"
                      href="https://www.google.com/maps/dir//Makerspace,+Lado+Gudiashvili+Square,+Tbilisi+0162,+Georgia/@41.6909958,44.8035254,17z/data=!4m7!4m6!1m1!4e2!1m2!1m1!1s0x40440d9a3542444f:0xc579f4ed091da767!3e0?source=lnms"
                    >
                      <h3>{t("location")}</h3>
                    </a>
                  </section>
                  <section className="socials-mobile">
                    <h2>{t("socials")}</h2>
                    <a
                      className="hover-effect"
                      href="https://www.instagram.com/makerspace_club/"
                      target="_blank"
                      rel="noopener noreferrer"
                      alt="Makerspace Instagram"
                      area-label="Makerspace Instagram"
                      name="instagram"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        fill="#FFFFFF"
                        stroke="currentColor"
                        height="25"
                        viewBox="0 0 50 50"
                      >
                        <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
                      </svg>
                    </a>
                    <a
                      className="hover-effect"
                      href="https://www.facebook.com/Makerspacebar?mibextid=LQQJ4d"
                      target="_blank"
                      rel="noopener noreferrer"
                      area-label="Makerspace Facebook"
                      alt="Makerspace Facebook"
                      name="facebook"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 30 30"
                        fill="currentColor"
                      >
                        <path d="M15,3C8.373,3,3,8.373,3,15c0,6.016,4.432,10.984,10.206,11.852V18.18h-2.969v-3.154h2.969v-2.099c0-3.475,1.693-5,4.581-5 c1.383,0,2.115,0.103,2.461,0.149v2.753h-1.97c-1.226,0-1.654,1.163-1.654,2.473v1.724h3.593L19.73,18.18h-3.106v8.697 C22.481,26.083,27,21.075,27,15C27,8.373,21.627,3,15,3z"></path>
                      </svg>
                    </a>
                    <a
                      className="hover-effect"
                      href="https://www.youtube.com/makerspacebar/"
                      target="_blank"
                      area-label="Makerspace Youtube"
                      alt="Makerspace Youtube"
                      rel="noopener noreferrer"
                      name="youtube"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        width="25"
                        height="25"
                        viewBox="0 0 50 50"
                        fill="currentColor"
                      >
                        <path d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z"></path>
                      </svg>
                    </a>
                    
                  </section>
                  <section className="footer-lang-mobile">
                    <h2>{t("language")}</h2>
                  <div
                    ref={toggleRef}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="25"
                      height="25"
                      viewBox="0 0 50 50"
                      fill="currentColor"
                    >
                      <path d="M 14 4 C 8.4886661 4 4 8.4886661 4 14 L 4 36 C 4 41.511334 8.4886661 46 14 46 L 36 46 C 41.511334 46 46 41.511334 46 36 L 46 14 C 46 8.4886661 41.511334 4 36 4 L 14 4 z M 25 9 C 33.82 9 41 16.18 41 25 C 41 25.47 40.979453 25.930625 40.939453 26.390625 C 40.339453 26.140625 39.69 26 39 26 L 26 26 L 26 38.830078 C 26.41 38.710078 26.809219 38.51 27.199219 38.25 C 28.039219 39.23 29.249141 39.880469 30.619141 39.980469 C 28.869141 40.640469 26.98 41 25 41 C 16.18 41 9 33.82 9 25 C 9 24.86 8.9997656 24.719844 9.0097656 24.589844 C 9.1297656 25.759844 10.010391 26.720937 11.150391 26.960938 C 11.530391 29.680937 12.700156 32.150625 14.410156 34.140625 C 15.240156 33.570625 16.120547 33.070391 17.060547 32.650391 C 16.470547 30.660391 16.109297 28.41 16.029297 26 L 13.830078 26 L 15.830078 24 L 24 24 L 24 11.169922 C 23.59 11.289922 23.190781 11.49 22.800781 11.75 C 21.960781 10.77 20.750859 10.119531 19.380859 10.019531 C 21.130859 9.3595312 23.02 9 25 9 z M 26 11.169922 L 26 16.960938 C 26.765 16.920938 27.518203 16.838437 28.251953 16.710938 C 28.985703 16.583438 29.700625 16.409453 30.390625 16.189453 C 30.118125 15.526953 29.815 14.915547 29.488281 14.361328 C 29.324922 14.084219 29.155684 13.821152 28.980469 13.574219 C 28.805254 13.327285 28.625391 13.095547 28.439453 12.880859 C 28.253516 12.666172 28.062715 12.469434 27.867188 12.289062 C 27.67166 12.108691 27.471563 11.944766 27.267578 11.800781 C 27.063594 11.656797 26.853887 11.531309 26.642578 11.425781 C 26.43127 11.320254 26.2175 11.234922 26 11.169922 z M 11 12 L 19 12 C 20.66 12 22 13.34 22 15 L 22 19 C 22 20.66 20.66 22 19 22 L 15 22 L 12.189453 24.810547 C 11.749453 25.250547 11 24.930547 11 24.310547 L 11 22 C 9.34 22 8 20.66 8 19 L 8 15 C 8 13.34 9.34 12 11 12 z M 30.339844 12.070312 C 30.524844 12.307813 30.704453 12.557578 30.876953 12.818359 C 31.049453 13.079141 31.215 13.349687 31.375 13.632812 C 31.535 13.915938 31.688437 14.211094 31.835938 14.515625 C 31.983438 14.820156 32.124766 15.135937 32.259766 15.460938 C 32.589766 15.310937 32.911563 15.149766 33.226562 14.978516 C 33.541562 14.807266 33.850391 14.624688 34.150391 14.429688 C 33.867891 14.184687 33.576172 13.950391 33.275391 13.728516 C 32.373047 13.062891 31.389844 12.505313 30.339844 12.070312 z M 35.580078 15.859375 C 35.170078 16.144375 34.744687 16.413359 34.304688 16.662109 C 33.864688 16.910859 33.409453 17.139609 32.939453 17.349609 C 33.234453 18.344609 33.472734 19.405078 33.646484 20.517578 C 33.733359 21.073828 33.803203 21.643672 33.857422 22.224609 C 33.911641 22.805547 33.950703 23.3975 33.970703 24 L 38.949219 24 C 38.921719 23.6125 38.87875 23.229688 38.820312 22.851562 C 38.761875 22.473437 38.689687 22.099922 38.601562 21.732422 C 38.513438 21.364922 38.409531 21.004062 38.292969 20.648438 C 38.176406 20.292813 38.046094 19.942109 37.902344 19.599609 C 37.758594 19.257109 37.601328 18.921875 37.431641 18.59375 C 37.261953 18.265625 37.079141 17.945312 36.884766 17.632812 C 36.690391 17.320312 36.485391 17.016328 36.267578 16.720703 C 36.049766 16.425078 35.820078 16.136875 35.580078 15.859375 z M 31.050781 18.080078 C 30.650781 18.207578 30.24375 18.321719 29.832031 18.421875 C 29.420313 18.522031 29.003906 18.608516 28.582031 18.681641 C 28.160156 18.754766 27.733203 18.814922 27.302734 18.861328 C 26.872266 18.907734 26.4375 18.940938 26 18.960938 L 26 24 L 31.970703 24 C 31.950703 23.4675 31.914609 22.941562 31.865234 22.425781 C 31.815859 21.91 31.753281 21.403828 31.675781 20.908203 C 31.598281 20.412578 31.506719 19.929063 31.402344 19.457031 C 31.297969 18.985 31.180781 18.525078 31.050781 18.080078 z M 18.029297 26 C 18.109297 28.13 18.429219 30.139922 18.949219 31.919922 C 19.349219 31.792422 19.75625 31.678281 20.167969 31.578125 C 20.579687 31.477969 20.996094 31.391484 21.417969 31.318359 C 22.261719 31.172109 23.125 31.079062 24 31.039062 L 24 26 L 18.029297 26 z M 31 28 L 39 28 C 40.66 28 42 29.34 42 31 L 42 35 C 42 36.66 40.66 38 39 38 L 39 40.310547 C 39 40.930547 38.250547 41.250781 37.810547 40.800781 L 35 38 L 31 38 C 29.34 38 28 36.66 28 35 L 28 31 C 28 29.34 29.34 28 31 28 z M 24 33.039062 C 23.6175 33.059062 23.23875 33.090469 22.863281 33.132812 C 22.487813 33.175156 22.114922 33.228594 21.748047 33.292969 C 21.381172 33.357344 21.018828 33.433438 20.662109 33.519531 C 20.305391 33.605625 19.954375 33.703047 19.609375 33.810547 C 19.881875 34.473047 20.185 35.084453 20.511719 35.638672 C 21.001797 36.47 21.54623 37.169824 22.132812 37.710938 C 22.523867 38.07168 22.934805 38.363164 23.357422 38.574219 C 23.56873 38.679746 23.7825 38.765078 24 38.830078 L 24 33.039062 z M 17.740234 34.539062 C 17.410234 34.689063 17.085781 34.850234 16.769531 35.021484 C 16.453281 35.192734 16.144609 35.375312 15.849609 35.570312 C 16.697109 36.305312 17.629219 36.939453 18.632812 37.455078 C 18.967344 37.626953 19.310156 37.784688 19.660156 37.929688 C 19.475156 37.692188 19.295547 37.442422 19.123047 37.181641 C 18.950547 36.920859 18.785 36.650312 18.625 36.367188 C 18.465 36.084063 18.311563 35.788906 18.164062 35.484375 C 18.016562 35.179844 17.875234 34.864063 17.740234 34.539062 z"></path>
                    </svg>
                    <button
                      onClick={() => switchLanguage(otherLang)}
                      className="lang-text"
                    >
                      {otherLabel}
                    </button>{" "}
                  </div>
                  </section>
                  <section className="footer-credit footer-credit-mobile">
                    <p>
                      Powered by{" "}
                        Synapse.ge
                    </p>
                  </section>
                </>
              </pre>
            </section>
          )}
          <footer className="footer-credit">
            <p>
              Powered by{" "}
                Synapse.ge
            </p>
          </footer>
        </section>
      </section>
    </>
  );
}
